import { render, staticRenderFns } from "./SearchTag.vue?vue&type=template&id=579b6ca0&"
import script from "./SearchTag.vue?vue&type=script&lang=ts&"
export * from "./SearchTag.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports